import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['continueButton']
  static values = { origin: { type: String, default: 'https://app.signlift.eu' } }

  connect() {
    this.onMessage = this.#revealOnSuccess.bind(this)
    window.addEventListener('message', this.onMessage)
  }

  disconnect() {
    window.removeEventListener('message', this.onMessage)
  }

  #revealOnSuccess(event) {
    if (event.origin !== this.originValue) return
    if (event.data?.type !== 'signlift:signature:success') return

    this.continueButtonTarget.classList.remove('d-none')
  }
}
